import { handleHideModal } from 'components/global/_helpers/global.helpers';
import SimpleModal from 'components/global/SimpleModal';
import UniversalInput from 'components/global/UniversalInput';
import { handleSubmitAddInvestorToDeal } from 'components/views/FounderInvestors/_helpers/founderInvestors.events';
import { PIPELINE_STATUS_OPTIONS } from 'constants/globalConstants';
import { $form, $view } from 'signals/global.signals';

const FounderAddToDealModal = () => (
  <SimpleModal
    show={$view.value?.activeModal === 'founder-investor-add-to-deal'}
    title={`Add ${$form.value?.investorName} to Deal`}
    isLoading={$view.value?.isModalLoading}
    onHide={handleHideModal}
    onPrimaryClick={handleSubmitAddInvestorToDeal}
    primaryButtonText="Save"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
  >
    <UniversalInput
      type="select"
      name="pipelineStatus"
      label="Pipeline Status"
      options={PIPELINE_STATUS_OPTIONS}
      className="mb-16"
    />
    <UniversalInput
      type="select"
      name="dealId"
      label="Deal"
      options={$view.value.investorDealOptions || []}
      className="mb-16"
    />
    <UniversalInput
      type="money"
      name="previouslyCommitted"
      label="Amount Committed"
      className="mb-16"
    />
    <UniversalInput
      type="money"
      name="amountInvested"
      label="Amount Invested"
      className="mb-16"
    />
  </SimpleModal>

);

export default FounderAddToDealModal;
